import translationsJson from './translations.json'

export const translations = translationsJson as Record<
  string,
  Record<string, string | undefined>
>
